import Resource from '@/plugins/sdk/Resource'
import { STRING, ITEM, UUID, DATETIME } from '@/plugins/sdk/fields'
import Consignment from '../Consignment'
import Profile from '../Profile'

export default class extends Resource {
  static name = 'tracking_error_report'

  static get fields () {
    return {
      id: new UUID(),
      name: new STRING(),
      consignment: new ITEM(Consignment),
      profile: new ITEM(Profile),
      message: new STRING(),
      created_at: new DATETIME(),
      updated_at: new DATETIME()
    }
  }
}
